module.exports = __webpack_public_path__ + "img/02-04-img-04.e6b07605.png";